var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var MegaMenu = function () {
	this.$veil = $( document.getElementById( 'veil' ) );
	this.$menu = $( document.getElementsByClassName( 'mega-menu' ) );
	this.$closeMenu = $( document.getElementById( 'close-menu' ) );
	this.$subMenus = $( document.getElementsByClassName( 'sub-menu' ) );
	this.$subMenusLis = $( document.querySelectorAll( '.sub-menu > ul > li.menu-item-has-children' ) );
	this.$hasChildren = $( document.querySelectorAll( '#menu-main-menu > li.menu-item-has-children > a, #product-filters > li.menu-item-has-children > a' ) );
	this.$backButton = $( document.getElementsByClassName( 'go-back' ) );
	this.$seeResults = $( document.getElementsByClassName( 'see-results' ) );
};

MegaMenu.prototype.init = function () {

	var self = this,
		hover;

	var in_menu = false;

	self.$closeMenu.click( function ( e ) {
		e.preventDefault();
		self.$veil.add( self.$menu ).add( self.$subMenus ).removeClass( 'open' );
		self.$veil.add( self.$menu ).add( self.$subMenus ).removeClass( 'scroll' );
		$( 'html, body' ).removeClass( 'disable-scroll' );
	} );
	self.$veil.click( function ( e ) {
		e.preventDefault();
		self.$veil.add( self.$menu ).add( self.$subMenus ).removeClass( 'open' );
		self.$veil.add( self.$menu ).add( self.$subMenus ).removeClass( 'scroll' );
		$( 'html, body' ).removeClass( 'disable-scroll' );
	} );
	self.$seeResults.click( function ( e ) {
		e.preventDefault();
		self.$veil.add( self.$menu ).add( self.$subMenus ).removeClass( 'open' );
		self.$veil.add( self.$menu ).add( self.$subMenus ).removeClass( 'scroll' );
		$( 'html, body' ).removeClass( 'disable-scroll' );
	} );

	$(document).on( 'facetwp-loaded', function() {

		// hide the all results link anyway
		$( '.sub-menu .facetwp-radio' ).on( 'click' , function(e) {
			$( this ).closest( '.sub-menu' ).find( '.see-results' ).hide();
		});
		// check if it should be displayed after filtering
		self.$subMenus.each( function(i) {
			if ( $( this ).find( '.facetwp-radio.checked' ).length > 0 ) {
				$( this ).find( '.see-results' ).show();
				$( this ).stop().animate({scrollTop:0}, 500, 'linear');
			} else {
				$( this ).find( '.see-results' ).hide();
			}
		});
	});



	self.$menu
		.on( 'mouseenter', function () {
			in_menu = true;
		} )
		.on( 'mouseleave', function () {
			in_menu = false;
		} );

	$( window ).load(function() {
		self.$hasChildren
			.click( function ( e ) {
				if ( $( window ).width() > 1000) {
					return;
				}

				e.preventDefault();

				$( this ).siblings( '.sub-menu' ).toggleClass( 'open' ).css( 'top', $( document.getElementById( 'mega-menu' ) ).scrollTop() );
				$( this ).parents( '#mega-menu' ).toggleClass( 'sub-open' );
			} );
	} );

	if ( $( window ).width() < 1000) {
		self.$subMenusLis.hide();
	}

	self.$hasChildren.parents( 'li' )
		.on( 'mouseenter', function () {

			if ( $( window ).width() < 1000 ) {
				return;
			}

			var $self = $( this );

			if ( in_menu ) {
				// $self.addClass( 'open' );
			} else {
				hover = setTimeout( function () {
					// $self.addClass( 'open' );
				}, 300 );
			}

		} )
		.on( 'mouseleave', function () {

			if ( $( window ).width() < 1000 ) {
				return;
			}

			clearTimeout( hover );
			// $( this ).removeClass( 'open' );

		} );

	self.$backButton.click( function ( e ) {
		e.preventDefault();
		$( this ).closest( '.sub-menu' ).removeClass( 'open' );
		$( this ).closest( '.sub-menu' )[0].style.top='';
		if ( $('#mega-menu .sub-menu.open').length == 0 ) {
			$( this ).parents( '#mega-menu' ).removeClass( 'sub-open' );
		}
	} );

};

module.exports = new MegaMenu;
